/** @jsxImportSource @emotion/react */
import closeBtn from '../../assets/icons/modalCloseBtn.svg';
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { Row } from '../flexbox';
import { XXXXLargeText } from '../../styles/styles';
import { doNothing } from '../../language/module';
import { getResource } from '../../language/resources/getResource';


const CloseButtonSizing = css`
  height: 40px;
  width: 40px;
  padding: 8px;
  margin: 20px;
  border-radius: 50%;
  border-width: 0;
`;

const CloseButton = styled('button')`
  ${CloseButtonSizing};
  background-color: transparent;
  cursor: pointer;
  
  &:hover {
    background-color: rgba( 0, 0, 0, .06);
  }
`;

const Title = styled('span')`
  ${XXXXLargeText};
  justify-self: center;
`;

const Icon = styled('img')`
  width: 40px;
  height: 40px;
  margin-right: 20px;
`;


export default class ModalTitleHeader extends React.PureComponent<{
  /**
   * The icon to show to the left of the modal title in the header
   */
  icon?: any,
  /**
   * The title text to show in the header of the modal
   */
  heading?: string,
  /**
   * Whether or not the user is allowed to dismiss this modal (default: true)
   */
  dismissable?: boolean,
  /**
   * When the user goes to dismiss this modal, what does the parent want us to do?
   */
  onDismiss?: () => void,
  /**
   * The style to apply to the modal header (image, title and close button)
   */
  rootCss?: SerializedStyles,

  resources: Record<string, any>,
}> {
  private onDismissModal = () => this.props.dismissable || this.props.dismissable === undefined
                                 ? (this.props.onDismiss || doNothing)()
                                 : doNothing();


  public render = () => (
    <Row alignItems='center' justifyContent='space-between' rootCss={css`min-height: 80px;`}>
      <Row alignItems='center'
            justifyContent='center'
            rootCss={css`
              flex-grow: 1; 
              text-align: center; 
              ${this.props.dismissable ? 'margin-left: 50px' : ''};
            `}>
        {
          this.props.icon && <Icon src={this.props.icon}/>
        }
        <Title>{this.props.heading || ''}</Title>
      </Row>
      {
        (this.props.dismissable || this.props.dismissable === undefined)
        && <CloseButton css={css`flex-basis: 40px;`}
                        title={getResource(this.props.resources, 'MODAL_TITLE_HEADER_CLOSE')}
                        onClick={this.onDismissModal}><img src={closeBtn} alt='Close'/></CloseButton>
      }
    </Row>
  );
}
